import { typedAxios, useReqParams } from './apiConfig';

export const useDeleteTeamUserById = () => {
  const reqParams = useReqParams({ url: '/teams/{teamid}/users/{userid}' });

  return (teamid: string, userid: string) => typedAxios({ ...reqParams, method: 'delete', params: { teamid, userid } });
};

export const useLitmosTokenTrigger = () => {
  const reqParams = useReqParams({ url: '/my/training/token' });

  return () => typedAxios({ ...reqParams, method: 'get' });
};
